/**
 * Spanish UI strings for Gamanza Engage widgets.
 * Points tooltips require these keys or the info icon shows empty content.
 * @see https://docs.gamanzaengage.com/docs/frontend-integration/Gamification/points-widget
 */
export const GAMANZA_ES_TRANSLATION_KEYS = {
  infoRank: "Tu rango actual en el programa de fidelización.",
  infoLevel: "Tu nivel actual. Gana XP para subir de nivel.",
  infoTokens: "Tokens disponibles para canjear en la tienda de recompensas.",
  infoXPPoints: "Puntos de experiencia hacia el siguiente nivel o rango.",
  // Flat + nested forms (docs list dotted keys for Minimum Activity downgrade)
  "rankMilestoneDescription.rounds": "Rondas mínimas requeridas para mantener tu rango actual.",
  "rankMilestoneDescription.totalBetAmount": "Apuesta total mínima requerida para mantener tu rango actual.",
  rankMilestoneDescription: {
    rounds: "Rondas mínimas requeridas para mantener tu rango actual.",
    totalBetAmount: "Apuesta total mínima requerida para mantener tu rango actual.",
  },
  activeBoosterDescription: "Este potenciador estará activo hasta la fecha de caducidad.",
};

export const buildGamanzaTranslations = () => [
  {
    locale: "es",
    keys: GAMANZA_ES_TRANSLATION_KEYS,
  },
];
